import React from 'react'
import './auth.styles.scss'
import '../form.styles.scss'

const AuthTemplate = (props) => {
    return (
        <section className="auth">
            <div className="container">
                {props.children}
            </div>
            <footer>
                <p>© 2025 NBA Effurun Branch, Delta State. All rights reserved.</p>
            </footer>
        </section>
    )
}

export default AuthTemplate